import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Card,
  Text,
  ButtonGroup,
  Button,
  Modal,
  TextField,
  Select,
  BlockStack,
  InlineStack,
  Box,
  Spinner,
  FormLayout,
  Image,
  Link,
  Divider,
  Tag,
  Toast,
  TextContainer,
  Icon,
  Thumbnail,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import MyPagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import {
  ChartFunnelIcon,
  ChartPopularIcon,
  EditIcon,
  ImagesIcon,
  LinkIcon,
  LocationIcon,
  LogoFacebookIcon,
  LogoInstagramIcon,
  LogoTiktokIcon,
  MobileIcon,
  PinIcon,
  PlusCircleIcon,
  QuestionCircleIcon,
  TeamIcon,
} from "@shopify/polaris-icons";
import countries from "../../Data/countries.json";
import lebanonIcon from "../../Assets/Images/lb.svg";
import iraqIcon from "../../Assets/Images/iq.svg";
import egyptIcon from "../../Assets/Images/eg.svg";

const Competitors = () => {
  const navigate = useNavigate();

  // Filters state
  const [search, setSearch] = useState("");
  const [priority, setPriority] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");
  const [priorityFilter, setPriorityFilter] = useState("All");
  const [countryFilter, setCountryFilter] = useState("All");
  const [timeline, setTimeline] = useState("All");
  const timelineButtons = [
    { label: "All", value: "All" },
    { label: "This Week", value: "week" },
    { label: "This Month", value: "month" },
  ];

  // Data state
  const [items, setItems] = useState(null);
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 50;
  const refBoolPage = useRef(true);
  const [activeShow, setActiveShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Toast
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive(!active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  // Modal Delete
  const [activeDelete, setActiveDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);

  const handleChangeModalShow = useCallback(() => {
    setActiveShow(!activeShow);
  }, [activeShow]);

  const handleChangeModalDelete = useCallback(() => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, [activeDelete]);

  const handleRowClick = (index) => {
    setCurrentIndex(index);
    setActiveShow(true);
  };

  const handleAddItem = () => {
    navigate("/admin/competitors/new");
  };

  const handleEdit = (id) => {
    navigate(`/admin/competitors/${id}`);
  };

  const handleScreenshots = (id) => {
    navigate(`/admin/competitors/${id}/screenshots`);
  };

  const handleNext = () => {
    if (currentIndex < result.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [country, setCountry] = useState("");
  // const countryButtons = [
  //   { label: "All", value: "All" },
  //   { label: "Lebanon", value: "Lebanon", icon: lebanonIcon },
  //   { label: "Egypt", value: "Egypt", icon: egyptIcon },
  //   { label: "Iraq", value: "Iraq", icon: iraqIcon },
  // ];

  // useEffect(() => {
  //   setOptionsCountries(
  //     Object.keys(countries).map((item, index) => {
  //       return {
  //         label: item,
  //         value: item,
  //       };
  //     })
  //   );
  // }, []);
  // Fetch data from API with filters
  useEffect(() => {
    fetchData();
  }, [page, search, typeFilter, countryFilter, priorityFilter, country]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);
      if (search) params.append("filter[business_name]", search);
      if (typeFilter !== "All") params.append("filter[type]", typeFilter);
      if (priorityFilter !== "All")
        params.append("filter[is_important]", priorityFilter);
      if (country !== "") params.append("filter[location]", country);
      // if (countryFilter !== "All")
      //   params.append("filter[location]", countryFilter);

      const response = await axios.get(`/competitors`, { params });
      const data = response.data.data.data;

      console.log("data=", data);
      setResult(data);
      setItems(
        data.map((item, index) => [
          <div
            data-row-index={index}
            style={{ width: "100px", height: "50px" }}
          >
            <img
              src={
                item.logo ||
                "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
              }
              alt="logo"
              className="img-fluid w-100 h-100"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain", // 👈 makes image fully cover the area
                display: "block",
              }}
            />
          </div>,
          <div data-row-index={index}>{item.business_name || "-"}</div>,
          <div data-row-index={index}>
            {String(item?.type?.id) === "1"
              ? "Direct"
              : String(item?.type?.id) === "2"
              ? "Indirect"
              : "International"}
          </div>,
          <div data-row-index={index}>
            {item.website ? (
              <Link
                monochrome
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(item.website, "_blank");
                }}
              >
                {item.website}
              </Link>
            ) : (
              "-"
            )}
          </div>,
          <div data-row-index={index}>
            <ButtonGroup>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(item.id);
                }}
                icon={EditIcon}
              >
                Edit
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );

      setTotalPages(response.data.data.total);
      setIsListEmpty(!data.length);
    } catch (err) {
      console.error(err);
      setIsListEmpty(true);
    }
    setIsLoading(false);
  };

  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage} />
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
    </div>
  ) : isLoading ? (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  ) : null;

  const [countryButtons, setCountryButtons] = useState([]);
  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        const countriesData = res?.data?.data || [];
        const options = [
          { label: "All", value: "" },
          { label: "Mutual", value: "All" },
          ...countriesData.map((country) => ({
            label: country.name,
            value: country.name,
            flag: country.flag,
          })),
        ];
        setCountryButtons(options);
        // setCountry(options?.[0]);
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    // Wait for DOM render
    const cells = document.querySelectorAll(".Polaris-DataTable__Cell");

    const handleClick = (e) => {
      const cell = e.currentTarget;
      const rowIndex = cell.querySelector("[data-row-index]")?.dataset.rowIndex;
      if (rowIndex !== undefined) {
        setCurrentIndex(Number(rowIndex));
        setActiveShow(true);
      }
    };

    cells.forEach((cell) => {
      // Avoid double-binding
      cell.removeEventListener("click", handleClick);
      cell.addEventListener("click", handleClick);
    });

    return () => {
      cells.forEach((cell) => cell.removeEventListener("click", handleClick));
    };
  }, [items]); // Re-run whenever table data updates

  return items ? (
    <Page
      title="Competitors"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem} icon={PlusCircleIcon}>
          Add Competitor
        </Button>
      }
      secondaryActions={
        <ButtonGroup>
          <Button
            onClick={() => navigate("/admin/brand-benchmark")}
            icon={ImagesIcon}
          >
            Screenshots
          </Button>
        </ButtonGroup>
      }
      fullWidth
    >
      {/* Filters Card */}
      <FormLayout>
        <Card>
          <BlockStack gap="500">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // 👈 centers both sides vertically
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              {/* 🔹 Left side: Filters */}
              <InlineStack gap="300" wrap align="center">
                <Box minWidth="260px">
                  <TextField
                    label="Search competitors"
                    value={search}
                    onChange={setSearch}
                    autoComplete="off"
                    placeholder="Search by name"
                  />
                </Box>

                <Select
                  label="Type"
                  value={typeFilter}
                  onChange={setTypeFilter}
                  options={[
                    { label: "All", value: "All" },
                    { label: "Direct", value: "1" },
                    { label: "Indirect", value: "2" },
                    { label: "International", value: "3" },
                  ]}
                />

                <Select
                  label="Priority"
                  value={priorityFilter}
                  onChange={setPriorityFilter}
                  options={[
                    { label: "All", value: "All" },
                    { label: "Important", value: "1" },
                    { label: "Not Important", value: "0" },
                  ]}
                />
              </InlineStack>

              {/* 🔹 Right side: Country buttons (centered vertically) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center", // 👈 vertical centering
                }}
              >
                <ButtonGroup segmented>
                  {countryButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={country === t.value}
                      onClick={() => setCountry(String(t.value))}
                    >
                      {t.flag && (
                        <img
                          src={t.flag}
                          alt={t.flag}
                          style={{ width: 20, marginRight: 6 }}
                        />
                      )}
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </div>
          </BlockStack>
        </Card>

        {/* DataTable */}
        {items?.length ? (
          <Card padding="0">
            <div className="clickable-table">
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={["Logo", "Name", "Type", "Website", ""]}
                rows={items}
                verticalAlign="middle"
                stickyHeader
                footerContent={
                  items?.length &&
                  `Showing ${items.length} of ${totalPages} results`
                }
              />
            </div>
          </Card>
        ) : (
          <Card>
            <div
              style={{
                display: "flex",
                justifyContent: "middle",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ width: "25%" }}>
                <img src={emptyListImage}></img>
              </div>
              <div className="mb-3">
                <Text variant="headingLg" as="h5" color="subdued">
                  No results found
                </Text>
              </div>
              <br />
            </div>
          </Card>
        )}

        {/* Pagination */}
        {Math.ceil(totalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <MyPagination
              count={Math.ceil(totalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )}
      </FormLayout>
      {/* Modals */}
      <Modal
        open={activeShow}
        onClose={handleChangeModalShow}
        title={result?.[currentIndex]?.business_name ?? ""}
        primaryAction={{
          content: "Next",
          onAction: handleNext,
          disabled: currentIndex === result?.length - 1,
        }}
        secondaryActions={[
          {
            content: "Previous",
            onAction: handlePrevious,
            disabled: currentIndex === 0,
          },
        ]}
      >
        <Modal.Section>
          <BlockStack gap="500">
            {/* 🔹 Website */}
            <InlineStack gap="200" align="left">
              <Thumbnail
                source={
                  result?.[currentIndex]?.logo ||
                  "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_small.png"
                }
                size="medium"
              />
              <Link
                monochrome
                onClick={() =>
                  result?.[currentIndex]?.website &&
                  window.open(result?.[currentIndex]?.website, "_blank")
                }
              >
                {result?.[currentIndex]?.website || "-"}
              </Link>
            </InlineStack>

            {/* 🔹 Location & Type */}
            <FormLayout.Group condensed>
              <BlockStack gap="100">
                <div className="iconLabel">
                  <Icon source={MobileIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    Mobile Apps
                  </Text>
                </div>
                <InlineStack gap="200">
                  <Tag
                    onClick={() =>
                      result?.[currentIndex]?.ios &&
                      window.open(result?.[currentIndex]?.ios, "_blank")
                    }
                  >
                    iOS
                  </Tag>
                  <Tag
                    onClick={() =>
                      result?.[currentIndex]?.android &&
                      window.open(result?.[currentIndex]?.android, "_blank")
                    }
                  >
                    Android
                  </Tag>
                </InlineStack>
              </BlockStack>
              <BlockStack gap="050">
                <div className="iconLabel">
                  <Icon source={LocationIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    Location
                  </Text>
                </div>
                <Text tone="subdued" breakWord>
                  {result?.[currentIndex]?.location || "-"}
                </Text>
              </BlockStack>

              <BlockStack gap="050">
                <div className="iconLabel">
                  <Icon source={QuestionCircleIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    Type
                  </Text>
                </div>
                <Text tone="subdued" breakWord>
                  {result?.[currentIndex]?.type
                    ? String(result?.[currentIndex]?.type) === "1"
                      ? "Direct"
                      : "Indirect"
                    : "-"}
                </Text>
              </BlockStack>
            </FormLayout.Group>

            {/* 🔹 Social Media Links */}
            {/* <FormLayout.Group condensed>
              {["facebook", "instagram", "tiktok"].map((platform) => (
                <BlockStack key={platform} gap="050">
                  <div className="iconLabel">
                    <Icon source={LinkIcon} tone="base" />
                    <Text as="p" fontWeight="semibold">
                      {platform.charAt(0).toUpperCase() + platform.slice(1)}
                    </Text>
                  </div>
                  {result?.[currentIndex]?.[platform] ? (
                    <Text breakWord>
                      <Link
                        monochrome
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(
                            result?.[currentIndex]?.[platform],
                            "_blank"
                          );
                        }}
                      >
                        {result?.[currentIndex]?.[platform]}
                      </Link>
                    </Text>
                  ) : (
                    <Text tone="subdued">–</Text>
                  )}
                </BlockStack>
              ))}
            </FormLayout.Group> */}

            {/* 🔹 Followers (keep original style) */}
            {/* 🔹 Followers */}
            <FormLayout.Group condensed>
              <BlockStack gap="050">
                <div
                  className="iconLabel"
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <Icon source={LogoFacebookIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    Facebook Followers
                  </Text>
                </div>

                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <Text tone="subdued">
                    {result?.[currentIndex]?.facebook_followers
                      ? Number(
                          result[currentIndex].facebook_followers
                        ).toLocaleString()
                      : "-"}
                  </Text>
                  {result?.[currentIndex]?.facebook && (
                    <div
                      onClick={() =>
                        window.open(
                          result[currentIndex].facebook,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                      style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        marginLeft: "2px",
                      }}
                    >
                      <Icon
                        source={LinkIcon}
                        tone="base"
                        accessibilityLabel="Open Facebook page"
                      />
                    </div>
                  )}
                </div>
              </BlockStack>

              <BlockStack gap="050">
                <div className="iconLabel">
                  <Icon source={LogoInstagramIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    Instagram Followers
                  </Text>
                </div>

                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <Text tone="subdued">
                    {result?.[currentIndex]?.instagram_followers
                      ? Number(
                          result[currentIndex].instagram_followers
                        ).toLocaleString()
                      : "-"}
                  </Text>
                  {result?.[currentIndex]?.instagram && (
                    <div
                      onClick={() =>
                        window.open(
                          result[currentIndex].instagram,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                      style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        marginLeft: "2px",
                      }}
                    >
                      <Icon
                        source={LinkIcon}
                        tone="base"
                        accessibilityLabel="Open Instagram page"
                      />
                    </div>
                  )}
                </div>
              </BlockStack>

              <BlockStack gap="050">
                <div className="iconLabel">
                  <Icon source={LogoTiktokIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    TikTok Followers
                  </Text>
                </div>

                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <Text tone="subdued">
                    {result?.[currentIndex]?.tiktok_followers
                      ? Number(
                          result[currentIndex].tiktok_followers
                        ).toLocaleString("en-US")
                      : "-"}
                  </Text>
                  {result?.[currentIndex]?.tiktok && (
                    <div
                      onClick={() =>
                        window.open(
                          result[currentIndex].tiktok,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                      style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        marginLeft: "2px",
                      }}
                    >
                      <Icon
                        source={LinkIcon}
                        tone="base"
                        accessibilityLabel="Open Tiktok page"
                      />
                    </div>
                  )}
                </div>
              </BlockStack>
            </FormLayout.Group>

            {/* 🔹 Other Details */}
            <FormLayout.Group condensed>
              <BlockStack gap="050">
                <div className="iconLabel">
                  <Icon source={ChartPopularIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    Estimated Sales
                  </Text>
                </div>
                <Text tone="subdued">
                  {result?.[currentIndex]?.estimated_sales
                    ? Number(
                        result[currentIndex].estimated_sales
                      ).toLocaleString("en-US")
                    : "-"}
                </Text>
              </BlockStack>

              <BlockStack gap="050">
                <div className="iconLabel">
                  <Icon source={TeamIcon} tone="base" />
                  <Text as="p" fontWeight="semibold">
                    Employees
                  </Text>
                </div>
                <Text tone="subdued">
                  {result?.[currentIndex]?.employees
                    ? Number(result[currentIndex].employees).toLocaleString(
                        "en-US"
                      )
                    : "-"}
                </Text>
              </BlockStack>
              <BlockStack gap="050"></BlockStack>
            </FormLayout.Group>

            {/* 🔹 Description */}
            <BlockStack gap="050">
              <div className="iconLabel">
                <Icon source={QuestionCircleIcon} tone="base" />
                <Text as="p" fontWeight="semibold">
                  Description
                </Text>
              </div>
              <Text tone="subdued" as="p">
                {result?.[currentIndex]?.description || "-"}
              </Text>
            </BlockStack>

            {/* 🔹 Why Considered Competitor */}
            <BlockStack gap="050">
              <div className="iconLabel">
                <Icon source={QuestionCircleIcon} tone="base" />
                <Text as="p" fontWeight="semibold">
                  Why Considered Competitor
                </Text>
              </div>
              <Text tone="subdued" as="p">
                {result?.[currentIndex]?.why_is_competitor || "-"}
              </Text>
            </BlockStack>

            {/* 🔹 Screenshots */}
            <BlockStack gap="100">
              <div className="iconLabel">
                <Icon source={ImagesIcon} tone="base" />
                <Text as="p" fontWeight="semibold">
                  Screenshots
                </Text>
              </div>
              {result?.[currentIndex]?.screenshots?.length > 0 ? (
                <InlineStack gap="200" wrap>
                  {result?.[currentIndex]?.screenshots.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`image-${index}`}
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                      onClick={() => window.open(img, "_blank")}
                    />
                  ))}
                </InlineStack>
              ) : (
                <Text tone="subdued">No Screenshots Uploaded</Text>
              )}
            </BlockStack>
          </BlockStack>
        </Modal.Section>
      </Modal>

      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default Competitors;
